enum DiagramEditActionTypeEnum {
  Add = 1,
  Delete = 2,
  Rename = 3,
  Layer = 4,
}

export type DiagramEditActionType = "add" | "delete" | "rename" | "layer" | "unknown";

export function toDiagramEditActionType(value: DiagramEditActionTypeEnum): DiagramEditActionType {
  switch (value) {
    case DiagramEditActionTypeEnum.Add: return "add";
    case DiagramEditActionTypeEnum.Delete: return "delete";
    case DiagramEditActionTypeEnum.Rename: return "rename";
    case DiagramEditActionTypeEnum.Layer: return "layer"
    default: return "unknown";
  }
}
